import { Box, Chip, Typography } from '@mui/material'
import React from 'react'
import { connect } from 'react-redux'
import AvatarWithLoader from 'components/avatar-with-loader'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import {
  Operations as UserAdminOperations,
  operations as userAdminOperations
} from 'states/dux/user-admin/operations'
import { Payload as UserAdminPayload } from 'states/dux/user-admin/types'
import {
  Operations as UserOperations,
  operations as userOperations
} from 'states/dux/user/operations'
import { Payload as UserPayload } from 'states/dux/user/types'
import State from 'states/types'
import { NivosUser } from 'types/user'
import { mapOperationsToDispatchProps } from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
  user: UserPayload
  userAdmin: UserAdminPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
    user: UserOperations
    userAdmin: UserAdminOperations
  }
}

interface OwnProps {
  userDetails: NivosUser
  onClickEvent: (user: NivosUser) => void
}

type AppProps = StateProps & DispatchProps & OwnProps

const UserCardFC: React.FC<any> = (props: AppProps) => {
  const { theme } = props
  const [hovered, setHovered] = React.useState(false)
  return (
    <Box
      border={1}
      borderRadius={8}
      borderColor={theme.secondaryColor}
      padding={2}
      margin={2}
      width={240}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={() => props.onClickEvent(props.userDetails)}
      sx={{
        cursor: 'pointer'
      }}
    >
      <Box
        margin={'auto'}
        paddingY={2}
        display={'flex'}
        flexDirection={'column'}
        alignItems={'center'}
      >
        <AvatarWithLoader
          src={props.userDetails.image?.url ?? ''}
          avatarProps={{
            sx: {
              height: 200,
              width: 200,
              transition: '0.5s',
              borderRadius: hovered ? 16 : 2
            }
          }}
        />
      </Box>
      <Box>
        <Typography
          variant={'h5'}
        >{`${props.userDetails.firstName} ${props.userDetails.lastName}`}</Typography>
        <Typography>{props.userDetails.address}</Typography>
        <Box
          width={1}
          borderBottom={1}
          borderColor={theme.secondaryColor}
          marginY={1}
          marginBottom={2}
        />
        <Box>
          {props.userDetails.groups.map((item, index) => (
            <Chip key={index} label={item.name} sx={{ marginRight: 1 }} />
          ))}
        </Box>
      </Box>
    </Box>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout,
    user: state.user,
    userAdmin: state.userAdmin
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations,
  user: userOperations,
  userAdmin: userAdminOperations
})

const UserAdminUserCard = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserCardFC) as React.FC<OwnProps>

export default UserAdminUserCard
